import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, useMediaQuery, useTheme } from '@mui/material';
import { psiTokens, lightButtonSx } from '../theme/psiTheme';

// Shared by the Home Services section and the standalone /services page.
export default function ServicesBanner() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${psiTokens.primary.dark} 0%, #7b3d92 50%, ${psiTokens.primary.light} 100%)`,
        borderRadius: '16px',
        border: `1px solid ${psiTokens.border}`,
        padding: isMobile ? 3 : 4,
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: 'space-between',
        gap: isMobile ? 2.5 : 4,
      }}
    >
      {/* Left accent */}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '5px',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
        }}
      />

      <Box>
        <Typography sx={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 700, color: '#ffffff', mb: 1 }}>
          Looking for a program tailored to your team's specific challenges?
        </Typography>
        <Typography sx={{ fontSize: '14px', fontWeight: 400, color: 'rgba(255, 255, 255, 0.75)' }}>
          PSI designs custom programs for any industry, team size, or delivery format.
        </Typography>
      </Box>

      <Button
        component={RouterLink}
        to="/contact"
        variant="contained"
        sx={{
          ...lightButtonSx,
          fontSize: '13px',
          fontWeight: 700,
          textTransform: 'uppercase',
          px: 3,
          py: 1.5,
          flexShrink: 0,
          width: isMobile ? '100%' : 'auto',
        }}
      >
        Contact Us
      </Button>
    </Box>
  );
}
